import moment from 'moment';

const formartDateTimeUTC = (date, format = 'DD/MM/YYYY HH:mm') => {
  if (!date) {
    return null;
  }

  if (format === 'fromNow') {
    let message = '';

    const today = moment();
    const years = today.diff(date, 'year');
    const months = today.add(-years, 'year').diff(date, 'month');
    const days = today.add(-months, 'month').diff(date, 'day');

    if (years > 0) {
      message += `${years} ${years > 1 ? 'anos, ' : 'ano, '}`;
    }

    if (months > 0) {
      message += `${months} ${months > 1 ? 'meses e ' : 'mês e '}`;
    }

    if (days > 0) {
      message += `${days} ${days > 1 ? 'dias' : 'dia'}`;
    }

    return message;
  }

  return moment(date).format(format);
};

export default formartDateTimeUTC;
